import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Iconify from '../iconify/Iconify';
import { IconButton, InputAdornment } from '@mui/material';

export default function TextInput({
    variant = 'outlined',
    id,
    name,
    type = 'text',
    getValue,
    className,
    ref,
    hiddenLabel,
    disabled,
    helperText,
    placeholder,
    required,
    size = 'small',
    readOnly,
    valueChange,
    uppercase = false,
    error = false,
    label,
    autoFocus = false,

    startAdornment = false,
    endAdornment = false,
    onEnterPress = () => null,
    icon = '',
}) {
    const [value, setValue] = React.useState('');
    const inputRef = React.useRef(null);
    const [showPassword, setShowPassword] = React.useState(false);
    const handleOnChange = (e) => {
        setValue(e.target.value);
        getValue && getValue(e.target.value);
    };
    const handleKeyDown = (e) => {
        // Check if the pressed key is "Enter" (key code 13)
        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
            // Call the onEnterPress function if it's provided
            // alert('ok');
            onEnterPress ? onEnterPress() : inputRef.current.blur();
        }
    };
    return (
        <Box>
            {type === 'password' ? (
                <TextField
                    size={size}
                    fullWidth
                    value={valueChange ? valueChange : value}
                    disabled={disabled}
                    helperText={helperText}
                    inputRef={ref}
                    className={className}
                    required={required}
                    name={name}
                    ref={inputRef}
                    onKeyDown={handleKeyDown}
                    placeholder={placeholder}
                    error={error}
                    readOnly={readOnly}
                    label={label}
                    hiddenLabel={hiddenLabel}
                    autoFocus={autoFocus}
                    onChange={handleOnChange}
                    id={id}
                    variant={variant}
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    disabled={disabled}
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            ) : (
                <TextField
                    size={size}
                    fullWidth
                    type={type}
                    value={valueChange ? valueChange : value}
                    disabled={disabled}
                    className={`${className} ${uppercase ? 'uppercase' : ''}`}
                    helperText={helperText}
                    ref={inputRef}
                    required={required}
                    onKeyDown={handleKeyDown}
                    InputProps={{
                        startAdornment: startAdornment && (
                            <InputAdornment position="start">{icon && <Iconify icon={icon} />}</InputAdornment>
                        ),
                        endAdornment: endAdornment && (
                            <InputAdornment position="end">
                                <IconButton
                                    disabled={disabled}
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    <Iconify icon={icon} />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    name={name}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    label={label}
                    hiddenLabel={hiddenLabel}
                    autoFocus={autoFocus}
                    error={error}
                    onChange={handleOnChange}
                    id={id}
                    variant={variant}
                />
            )}
        </Box>
    );
}
